import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Provider } from 'jotai'
import { EditorProvider } from '../../../../ui'

export const Route = createFileRoute('/_auth/company/$companyId/campaign')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<Provider>
			<EditorProvider>
				<Outlet />
			</EditorProvider>
		</Provider>
	)
}
